import auth from "@/middleware/auth";

export default [
    {
        path: "vencimentoAVista",
        name: "vencimentoAVista",
        meta: { middleware: [auth] },
        component: () => import("./VencimentoAVista")
    }
];
